/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import {
  AutoSaveField as Field,
  CustomSelect,
  Input,
  InputGroup,
  LinkedField
} from "../../../../components/Form";
import { Card } from "../../../../components/v2/Card/Card";

/**
 * PreferredContactInformation component for rendering contact information form fields
 *
 * @param {Object} props - Component props
 */
export const PreferredContactInformation = ({
  index,
  values,
  isPreferredContactDisable,
  isPreferredContactOptional
}) => {
  const isRequired = !isPreferredContactOptional;
  return (
    <Card title="Preferred contact information">
      <Field
        name="primaryEmail"
        path={`prospect.signatoryInfo[${index}].contactDetails.preferredEmail`}
        label={isRequired ? "E-mail address" : "E-mail address (Optional)"}
        placeholder="E-mail address"
        component={Input}
        disabled={isPreferredContactDisable}
        InputProps={{
          inputProps: { maxLength: 50, tabIndex: 0 }
        }}
      />
      <Grid item container spacing={3} sx={{ mt: 0 }}>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            pt: "0px !important"
          }}
        >
          <InputGroup>
            <LinkedField
              name="primaryMobCountryCode"
              linkedFieldName="primaryMobileNo"
              path={`prospect.signatoryInfo[${index}].contactDetails.preferredMobileCountryCode`}
              linkedPath={`prospect.signatoryInfo[${index}].contactDetails.preferredMobileNo`}
              component={CustomSelect}
              shrink={false}
              disabled={isPreferredContactDisable}
              datalistId="countryCode"
              inputProps={{ tabIndex: 0 }}
            />
            <LinkedField
              name="primaryMobileNo"
              linkedFieldName="primaryMobCountryCode"
              path={`prospect.signatoryInfo[${index}].contactDetails.preferredMobileNo`}
              linkedPath={`prospect.signatoryInfo[${index}].contactDetails.preferredMobileCountryCode`}
              label={isRequired ? "Mobile Number" : "Mobile Number (Optional)"}
              placeholder="55xxxxxxx"
              component={Input}
              disabled={isPreferredContactDisable}
              InputProps={{
                inputProps: { tabIndex: 0 }
              }}
              contextualHelpText="This number will be used as primary contact for any future communication"
            />
          </InputGroup>
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            pt: {
              xs: "16px !important",
              sm: "0px !important"
            }
          }}
        >
          <InputGroup>
            <Field
              name="primaryPhoneCountryCode"
              path={`prospect.signatoryInfo[${index}].contactDetails.preferredPhoneCountryCode`}
              component={CustomSelect}
              shrink={false}
              disabled={isPreferredContactDisable}
              datalistId="countryCode"
              inputProps={{ tabIndex: 0 }}
            />

            <Field
              name="primaryPhoneNo"
              path={`prospect.signatoryInfo[${index}].contactDetails.preferredPhoneNo`}
              label={isRequired ? "Landline number" : "Landline number (Optional)"}
              placeholder="42xxxxxx"
              component={Input}
              disabled={isPreferredContactDisable}
              InputProps={{
                inputProps: { tabIndex: 0 }
              }}
            />
          </InputGroup>
        </Grid>
      </Grid>
    </Card>
  );
};

PreferredContactInformation.propTypes = {
  /**
   * Index of the stakeholder
   */
  index: PropTypes.number.isRequired,
  /**
   * Form values object from Formik
   */
  values: PropTypes.object.isRequired,
  /**
   * Flag indicating if form fields should be disabled
   */
  isPreferredContactDisable: PropTypes.bool.isRequired,
  /**
   * Flag indicating if contact information is optional
   */
  isPreferredContactOptional: PropTypes.bool.isRequired
};
